module.exports = __webpack_public_path__ + "img/stock2.f178508d.png";